import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { PositionListComponent } from './position-list/position-list.component';
import { PositionSearchComponent } from './position-search/position-search.component';
import { LongShortPipe } from "../../shared/longshort.pipe";



@NgModule({
    declarations: [PositionListComponent, PositionSearchComponent],
    imports: [
        CommonModule,
        SharedModule,
        LongShortPipe
    ]
})
export class PositionModule { }
